// @flow

import type {Breakpoint} from '@travel-frontend/themes';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_BREAKPOINT = 'uiState/layout/base/SET_BREAKPOINT';

export type SetBreakpoint = {
  breakpoint: Breakpoint,
};

export function setBreakpoint(breakpoint: Breakpoint): {
  breakpoint: Breakpoint,
  type: string,
  ...
} {
  return {
    type: PURE(SET_BREAKPOINT),
    breakpoint,
  };
}
